

























































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { faComments } from '@fortawesome/free-solid-svg-icons'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'

export default Vue.extend({
  components: {
    QnaPayAttention: () => import('~/components/car/qna/QnaPayAttention.vue'),
    CTextArea
  },
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    quickReply: { type: Boolean, default: false },
    withArrow: { type: Boolean, default: true },
    answer: { type: String, default: null },
    submitButtonTitle: { type: String, default: null },
    autofocus: { type: Boolean, default: true },
    cancelButtonVisible: { type: Boolean, default: true },
    headerVisible: { type: Boolean, default: true },
    displayInModal: { type: Boolean, default: false },
    showCloseBtn: { type: Boolean, default: false }
  },
  data() {
    return {
      answerText: this.answer || '',
      isModalVisible: false,
      icons: {
        answer: faComments
      }
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    isSubmitButtonDisabled() {
      return (
        this.disabled || this.answerText?.trim()?.length === 0 || this.loading
      )
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', this.answerText.trim())
    },
    clearText() {
      this.answerText = ''
    }
  }
})
